<script setup lang="ts">
import { computed, ref } from 'vue';
import Popover from 'primevue/popover';
import type { NamedTracker } from '@/utils/named-tracker-set';
import { buildTrackerSetView } from '@/utils/named-tracker-set';
import NamedTrackerRoster from './NamedTrackerRoster.vue';

const props = defineProps<{
  trackers: NamedTracker[];
}>();

const view = computed(() => buildTrackerSetView(props.trackers));
const popoverRef = ref<{ toggle: (event: Event) => void } | null>(null);

function handleToggle(event: Event) {
  event.stopPropagation();
  popoverRef.value?.toggle(event);
}
</script>

<template>
  <span v-if="view.kind === 'empty'" class="text-sm text-neutral-500"> — </span>
  <span
    v-else-if="view.kind === 'single'"
    class="text-sm text-neutral-800"
    :title="view.label"
  >
    {{ view.label }}
  </span>
  <span v-else data-row-actions class="inline-flex min-w-0">
    <button
      type="button"
      class="inline-flex max-w-full items-center rounded-md bg-neutral-100 px-1.5 py-0.5 text-sm font-medium text-neutral-800 hover:bg-neutral-200"
      :aria-label="`${view.collapsedLabel}. Show tracker names.`"
      @click="handleToggle"
    >
      <span class="truncate">{{ view.collapsedLabel }}</span>
    </button>
    <Popover ref="popoverRef" append-to="body">
      <NamedTrackerRoster :trackers="view.trackers" />
    </Popover>
  </span>
</template>
